export default __webpack_public_path__ + "assets/models/020c183060daf0660f466482ce481a61.glb";